import { environment } from "src/environments/environment";

export const API_DOMAIN_EXTERNAL = {
    url: environment.domainendpoint + 'api/myceTeacherSignupResource'
};

export const API_PATH = {
    createDigitalMaterial: 'api/myce/material/createMaterial',
    createPaperMaterial: 'api/myce/material/createPaperMaterial',
    submitContactUs: 'api/myce/material/submitContactUs',
    getQuizAnswer: 'api/myce/material/getQuizAnswer',
    getSchoolMetaData: 'api/myce/signup/schoolMetaData/',
    createSchoolMetaData: 'api/myce/signup/createSchoolMetaData',
    getHowDidYouHearAboutUs: 'api/myce/signup/howDidYouHearAboutUs/',
    savePublicLearningLibraryScore: 'api/myce/material/savePublicLearningLibraryScore'
};
